function IngredientSearchWireUpEvents()
{

  IngredientSearchEnterKeyListener();
}

function IngredientSearchEnterKeyListener()
{
  document.addEventListener("keydown", function(event) {
      if (event.key === "Enter") {
          const activeElement = document.activeElement;
          if (activeElement.type === "button" || activeElement.type === "text") {
            let grandparent = activeElement.parentElement?.parentElement;

            if (grandparent && grandparent.classList.contains("ingredient-search-container")) {
              IngredientSearch();
            }
          }
      }
  });
}


function IngredientSearch()
{
  var searchInput = document.querySelector('.ingredient-search-input input').value;
  searchInput = encodeURI(searchInput);
  window.location.href = "/search?view=nw-ingredient-search&filter.p.m.custom.ingredient_detail_search_enabled=1&q=" + searchInput;
}


function QualityCheckSearch()
{
  ///search?view=nw-search-json-results&q=elder

  fetch('/search.json?view=nw-search-json-results&q=elder')
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        console.log("QualityCheckSearch response:");
        console.log(response);
        return response.json();
    })
    .then(data => {
        console.log('Received JSON:', data);
    })
    .catch(error => {
        console.error('Error fetching JSON:', error);
    });

}

addEventListener("DOMContentLoaded", (event) => {  IngredientSearchWireUpEvents(); });